import React, { useEffect, useState } from "react";
import MailLockIcon from "../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg";
import { Link, useNavigate } from "react-router-dom";
import NoReply from "./NoReply";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import CallAPI from "../../services/apiCalls";

const DetailsOrgEmails = ({ detailsEmail, emailRefresh }) => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    SetSharedObject,
    sharedObject,
    XdrArr,
    userSession,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    XdrArr: state.XdrArr,
    userSession: state.userSession,
  }));
  const [collapse, SetCollapse] = useState(false);
  const [flag, setFlag] = useState(false);
  const [answers, setAnswers] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [sharedFlag, setSharedFlag] = useState(false);
  const [emlShareObj, setEmlShareObj] = useState([]);
  const [emlForwarding, setEmlForwarding] = useState([]);
  const [msg, setMsg] = useState(
    "Email purpose has been updated successfully."
  );
  const [msgModal, setMsgModal] = useState(
    "Unchecking this box will remove all users access to this email box."
  );
  const [errMsg, setErrMsg] = useState(
    "Email purpose cannot be updated at this time. Please contact customer support for further assistance."
  );
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [xdrAccessOrg, setXdrAccessOrg] = useState(false);
  useEffect(() => {
    setSubmitFlag(false);
    if (flag) navigate(flag, { replace: true });
    const temp = [];
    let obj = sharedObject.emailsSharing;
    if (obj && obj.length > 0) {
      for (const el of obj) {
        el.show = true;
        temp.push(el);
      }
    }
    setEmlShareObj(temp);
    if (
      Object.keys(detailsEmail).length > 0 &&
      detailsEmail.constructor === Object
    ) {
      DetailEmailFunc(detailsEmail);
      setXdrAccessOrg(sharedObject.orgActionObj?.xdrEnabled);
      //getXDRData(detailsEmail.organizationId);
      if (detailsEmail.emailForwording) {
        setEmlForwarding(detailsEmail.emailForwording);
      }
    }
  }, [flag, navigate, detailsEmail, sharedObject.emailsSharing]);
  const DetailEmailFunc = async (detailsEmail) => {
    await setAnswers({
      ...answers,
      Purpose:
        detailsEmail.emailType === "userEmails" ||
        detailsEmail.emailType === "orgEmails"
          ? detailsEmail.emailPurposeId
          : detailsEmail.directEmailPurposeId,
      KeepMdn:
        detailsEmail.emailType === "orgEmails" ||
        detailsEmail.emailType === "userEmails"
          ? detailsEmail.keepMDN
            ? 1
            : 0
          : detailsEmail.isKeepMDN
          ? 1
          : 0,
      SharingAllowed: detailsEmail.sharingAllowed,
      NoReply: detailsEmail.noReply,
    });
  };
  const UnAssignEmail = async (id, userId, flag) => {
    var uId = userId ? userId : userSession.vendor_id;
    if (!flag) setSubmitFlag(true);
    setProcessing(true);
    let call =
      "/emails/RemoveSharedEmail?directEmailId=" +
      parseInt(id) +
      "&userId=" +
      uId;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      if (flag) {
        setEmlShareObj([]);
      } else {
        for (const elx of emlShareObj) {
          if (elx.userId === uId) {
            elx.show = false;
          }
          temp.push(elx);
        }
        setEmlShareObj(temp);
        setMsg("User have been unassigned successfully.");
      }
      if (!flag) setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      setErrMsg(
        "Email sharing cannot be removed at this time. Please contact customer support for further assistance."
      );
      setSuccessFlag(false);
    }
    setProcessing(false);
  };
  const UpdateEmail = async () => {
    setSubmitFlag(true);
    setProcessing(true);
    let mdn = answers.KeepMdn === 1 ? true : false;
    let call =
      "/emails/UpdateDirectEmail?directEmailId=" +
      parseInt(detailsEmail.directEmailId) +
      "&purposeId=" +
      answers.Purpose +
      "&IsKeepMDN=" +
      mdn +
      "&NoReply=" +
      answers.NoReply;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let uId = detailsEmail.organizationId;
      let detEmails = {
        ...detailsEmail,
        Id: uId,
        Flag: detailsEmail.emailType,
      };
      emailRefresh(detEmails);
      setMsg("Email has been updated successfully.");
      setSuccessFlag(true);
      detailsEmail.directEmailPurposeId = answers.Purpose;
      detailsEmail.isKeepMDN = mdn;
    } else if (res.status === "SERVERERROR") {
      setMsg(
        "Email cannot be updated at this time. Please contact customer support for further assistance."
      );
      setSuccessFlag(false);
    }
    setProcessing(false);
  };
  const ConfirmUnsharing = async () => {
    let call =
      "/emails/UpdateOrgSharingEmail?directEmailId=" +
      parseInt(detailsEmail.directEmailId) +
      "&organizationId=" +
      detailsEmail.organizationId +
      "&sharingAllowed=" +
      answers.SharingAllowed;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let tmp = [];
      for (let e of sharedObject.emailListObj) {
        if (e.directEmailId === detailsEmail.directEmailId)
          e.sharingAllowed = answers.SharingAllowed;
        tmp.push(e);
      }
      SetSharedObject("emailListObj", tmp);
      if (!answers.SharingAllowed)
        for (let el of emlShareObj) {
          await UnAssignEmail(el.id, el.userId, true);
        }
      $("#ConfirmUnsharingModal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      $("#ConfirmUnsharingModal").modal("hide");
    }
  };

  const CloseModal = () => {
    setAnswer("SharingAllowed", !answers.SharingAllowed);
    $("#ConfirmUnsharingModal").modal("hide");
  };
  return (
    <div className="DetailsOrgEmails">
      <div
        className="modal fade"
        id="detailsEmailOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsEmailOrg"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                {" "}
                Details{" "}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header spacer-margin3">
                    <img src={MailLockIcon} alt="Email Lock Icon" />
                    <div className="details-name">
                      {detailsEmail.directEmailAddress}
                    </div>
                  </div>
                  <section className="field-wrapper">
                    {detailsEmail.emailType ? (
                      <>
                        <label>Email Type:</label> {detailsEmail.emailType}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {detailsEmail.emailType === "User" ||
                    detailsEmail.emailType === "userEmails" ? (
                      <>
                        <label for="UserName">Username:</label>
                        <span>{detailsEmail?.userName?.split("|")[0]}</span>
                        <br />
                        <label for="FirstName">Name:</label>
                        <Link
                          onClick={(el) => {
                            let nm = detailsEmail.name;
                            let o = {
                              //OrganizationId: detailsEmail.organizationId,
                              //Id: detailsEmail.organizationId,
                              //CustomerId: detailsEmail.CustomerId,
                              UserName: detailsEmail.userName.split("|")[0],
                              Name: detailsEmail.name,
                              OrgName:
                                sharedObject?.orgDetails?.organizationName,
                              Navigate: "detailUser",
                              Flag: "orgEmails",
                              //UserEmail: detailsEmail.directEmailAddress,
                            };
                            SetSharedObject("UserIdEmail", o);
                            $(".modal").modal("hide");
                            setFlag("/users");
                          }}
                        >
                          {detailsEmail.name}
                        </Link>
                        <br />
                      </>
                    ) : (
                      <>
                        <label for="OrgName">Organization:</label>
                        <span>
                          <Link
                            onClick={(el) => {
                              let o = {
                                OrganizationId: detailsEmail?.organizationId,
                                CustomerId: detailsEmail?.CustomerId,
                                id: sharedObject?.orgDetails?.vendorId,
                                Id: detailsEmail?.organizationId,
                                Name: detailsEmail?.name,
                                OrgName:
                                  sharedObject?.orgDetails?.organizationName,
                                Navigate: "orgEmails",
                                Flag: "orgEmails",
                              };
                              SetSharedObject("UserIdEmail", o);
                              $(".modal").modal("hide");
                              setFlag("/organizations");
                            }}
                          >
                            {detailsEmail.name}
                          </Link>
                        </span>
                        <br />
                      </>
                    )}
                    <label for="CreatedDate">Created Date:</label>
                    <span>
                      {new Date(detailsEmail.dateCreated).toLocaleString()}
                    </span>
                    <br />
                    <label for="CreatedBy">Created By:</label>
                    <span>{detailsEmail.createdBy?.split("|")[0]}</span>
                  </section>

                  <section>
                    <div className="field-wrapper">
                      {xdrAccessOrg ? (
                        <>
                          <label for="OutboundXDR">
                            Inbound XDR:
                          </label>
                          <span>
                            {sharedObject?.orgActionObj?.xdrEnabled
                              ? "Enabled"
                              : "Disabled"}
                          </span>
                          <aside>
                            <div className="sub-catg">
                              <label for=" ConfigName">Config Name:</label>
                              {sharedObject?.xdrSettiingObj?.endpointName}
                              <br />
                              <label for=" EndpointUrl">Endpoint URL:</label>
                              <span className="word-set">
                                {sharedObject?.xdrSettiingObj?.endpointAddress}
                              </span>
                              <br />
                              <label for="ReceiveMDN">Deliver MDN:</label>
                              {sharedObject?.xdrSettiingObj?.mdnForward
                                ? "Yes"
                                : "No"}
                              <br />
                              <label for="">
                                Deliver Message Body for XDM Messages:
                              </label>
                              <span>
                                {sharedObject.xdrSettiingObj?.sendXDMBody
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </aside>
                          <div className="sp-margin3">
                            <label for="InboundXDR">Outbound XDR</label>
                          </div>
                          <div className="sub-catg">
                            <label for=" XdmDeliver">XDM Delivery:</label>
                            <span>
                              {sharedObject.orgActionObj?.xdrDoNOTGenerateXDM
                                ? "Yes"
                                : "No"}
                            </span>
                            <br /> <label for=" Oon">Out of Network:</label>
                            <span>
                              {sharedObject.orgActionObj?.outOfNetwork
                                ? "Yes"
                                : "No"}
                            </span>
                            <br />
                            <label for="ReceiveMDN">
                              Create Direct Automatically:
                            </label>
                            <span>
                              {sharedObject.orgActionObj
                                ?.inboundCreateDirectAuto
                                ? "Yes"
                                : "No"}
                            </span>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </section>
                  {detailsEmail.emailType !== "orgEmails" &&
                  detailsEmail.emailType !== "Organization" ? (
                    <>
                      <div className="field-wrapper label-divider">
                        <div className="sp-margin7 spacer-inline">
                          MESSAGE FORWARDING
                        </div>
                        <div className="v-set2 spacer-inline float-r">
                          <a
                            href="javascript:void(0);"
                            className="btn btn-info min-wsm"
                            onClick={(el) => {
                              SetCollapse(!collapse);
                            }}
                            role="button"
                            aria-controls="msg-fwd"
                          >
                            <i
                              className={`bi ${
                                collapse ? "bi-plus" : "bi-dash"
                              }`}
                            ></i>
                          </a>
                        </div>
                      </div>
                      <section
                        aria-labelledby="Message Fowarding List"
                        id="msg-fwd"
                        className={`field-wrapper ${
                          collapse ? "collapse" : null
                        }`}
                      >
                        {emlForwarding.length > 0 ? (
                          emlForwarding?.map((el) => {
                            return (
                              <div className="field-wrapper sub-catg">
                                <div>
                                  <label>Forwarding To:</label>
                                  <div className="word-set">
                                    {el.forwardingEmailAddress}
                                  </div>
                                </div>
                                <label>Status:</label>
                                <span>{el.forwardingStatus}</span>
                                <br />
                                <label>Type:</label>
                                <span>{el.forwardingContentType}</span>
                                <br />
                                <label>Start Date:</label>
                                <span>
                                  {new Date(
                                    el.forwardingStartDate
                                  ).toLocaleString()}
                                </span>
                                <br />
                                <label>End Date:</label>
                                <span>
                                  {new Date(
                                    el.forwardingEndDate
                                  ).toLocaleString()}
                                </span>
                              </div>
                            );
                          })
                        ) : (
                          <div className="field-wrapper sub-catg">
                            There are no forwarding emails currently set up.
                          </div>
                        )}
                      </section>
                    </>
                  ) : (
                    <>
                      <div className="field-wrapper label-divider">
                        <div className="sp-margin7 spacer-inline">
                          MEMBERS ASSIGNED
                        </div>
                        <div className="sp-margin3 spacer-inline float-r">
                          <details data-popover="up">
                            <summary>
                              <i className="bi bi-info-circle text-size9"></i>
                            </summary>
                            <aside>
                              <div className="icon-sign or-clr">
                                <i className="bi bi-info-circle"></i>
                              </div>
                              <div className="sp-margin4">
                                Organization emails can be used for multiple
                                members if sharing is allowed. They will have
                                full access to the same mailbox to send and
                                receive emails.
                              </div>
                            </aside>
                          </details>
                        </div>
                      </div>
                      <div className="spacer-margin8">
                        <label>Sharing Allowed:</label>
                        <div className="spacer-inline ctr">
                          <input
                            type="checkbox"
                            className="form-control"
                            id="SharingAllowed"
                            checked={answers?.SharingAllowed}
                            value={answers?.SharingAllowed}
                            onChange={(e) => {
                              if (answers?.SharingAllowed) {
                                setMsgModal(
                                  "Unchecking this box will remove all users from this mailbox."
                                );
                              } else {
                                setMsgModal(
                                  "Sharing this organization email will allow all assigned users to send and receive messages from this mailbox."
                                );
                              }
                              setAnswer("SharingAllowed", e.target.checked);
                              $("#ConfirmUnsharingModal").modal("show");
                            }}
                          />
                        </div>
                      </div>
                      <div></div>
                      <div className="field-wrapper">
                        <table>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            {/* <th>Last Activity</th> */}
                            <th></th>
                          </tr>
                          {emlShareObj?.map((el) => {
                            if (el.show) {
                              return (
                                <tr>
                                  <td>
                                    <span className="dot-gr"></span>
                                  </td>
                                  <td>{el.name}</td>
                                  <td>
                                    <a
                                      href="javascript:void(0);"
                                      onClick={(e) =>
                                        UnAssignEmail(el.id, el.userId)
                                      }
                                      rel="noreferrer"
                                    >
                                      <i className="bi bi-x-circle"></i>
                                    </a>
                                  </td>
                                </tr>
                              );
                            }
                          })}
                        </table>
                        {emlShareObj?.length === 0 ? (
                          <div className="sub-catg">
                            There are no users assigned to this email.
                          </div>
                        ) : null}
                      </div>
                      <div className="field-wrapper">
                        If sharing is not allowed, then only one member can be
                        assigned to use this mailbox.
                      </div>
                    </>
                  )}
                  {/*Email Delivery*/}
                  <div className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Email Delivery
                    </div>
                  </div>
                  <section className="field-wrapper sp-margin4">
                    <div className="spacer-inline w-md6">
                      <label>Purpose</label>
                      <div>
                        <select
                          className="form-control"
                          name="Purpose"
                          id="Purpose"
                          onChange={(el) =>
                            setAnswer("Purpose", parseInt(el.target.value))
                          }
                          value={answers?.Purpose}
                        >
                          <option value={0}>General</option>
                          <option value={1}>Medical Records XML Only</option>
                          <option value={2}>Medical Records</option>
                          <option value={3}>Administrative</option>
                        </select>
                      </div>
                    </div>
                    <div className="spacer-inline spacer-margin2">
                      <label>Keep MDN</label>
                      <div>
                        <select
                          className="form-control"
                          name="KeepMdn"
                          id="KeepMdn"
                          onChange={(el) =>
                            setAnswer("KeepMdn", parseInt(el.target.value))
                          }
                          value={answers?.KeepMdn}
                        >
                          <option value={1}>Yes</option>
                          <option value={0}>No</option>
                        </select>
                      </div>
                    </div>
                  </section>
                  {submitFlag && successFlag ? (
                    <div className="alert alert-success" role="alert">
                      {msg}
                    </div>
                  ) : null}
                  {submitFlag && !successFlag ? (
                    <div className="alert alert-danger" role="alert">
                      {errMsg}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={UpdateEmail}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="ConfirmUnsharingModal"
        data-backdrop="false"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Confirmation</div>
              <button
                type="button"
                className="close"
                onClick={(e) => CloseModal()}
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="alert-warning-o">
              <i
                className="bi bi-exclamation-circle"
                alt="Alert Warning Sign"
              ></i>
            </div>
            <div className="message-wrapper sp-pad3">{msgModal}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={(el) => ConfirmUnsharing()}
              >
                Confirm
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={(e) => {
                  CloseModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsOrgEmails;
